<div class="row">
	<div class="cols">
		<div class="icon">
			<div class="message-type">
				<div class="inner">
					<i class="fas fa-times"></i>
					<i class="fas fa-check"></i>
					<i class="fas fa-info"></i>
					<i class="fas fa-warning"></i>
				</div>
			</div>
		</div>
		<div class="content">
			<div class="title"
				*ngIf="title"
				role="alert" aria-live="polite"
				[class]="options.messageClass"
			>
				<span *ngIf="options?.enableHtml" [innerHTML]="title"></span>
				<span *ngIf="!options?.enableHtml">
					{{ title }}
				</span>
			</div>
			<div class="message-body"
				*ngIf="message"
				role="alert" aria-live="polite"
				[class]="options.messageClass"
			>
				<span *ngIf="options?.enableHtml" [innerHTML]="message"></span>
				<span *ngIf="!options?.enableHtml">
					{{ message }}
				</span>
			</div>
		</div>
	</div>
	<div class="close icon" *ngIf="options.closeButton" (click)="remove()">
		<i class="fas fa-times"></i>
	</div>
	<div *ngIf="options.progressBar" class="progress-wrapper">
		<div class="toast-progress" [style.width]="width + '%'"></div>
	</div>
</div>
